import Vue from "vue";
import Router from "vue-router";
import Layout from "@/views/layout/Layout.vue";

Vue.use(Router);

/*
  redirect:                      if `redirect: noredirect`, it won't redirect if click on the breadcrumb
  meta: {
    title: 'title'               the name showed in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if `hidden: true`, this route will not show in the sidebar (default is false)
    alwaysShow: true             if set to true, it will always show the root menu
                                 if not set, only show with nested mode if there are more than one route under its children
  }
*/

export default new Router({
  // mode: "history",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/login/index.vue")
    },
    {
      path: "/404",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue")
    },
    {
      path: "/",
      component: Layout,
      name: "Home",
      redirect: '/dashboard',
      meta: { title: "VTL CM", icon: "portal", alwaysShow: true, },
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          component: () =>
            import(/* webpackChunkName: "home-index" */ "@/views/home/dashboard.vue"),
          meta: { title: "dashboard", icon: "dashboard", roles: ['admin'] }
        },
        {
          path: "report",
          name: "report",
          component: () =>
            import(/* webpackChunkName: "home-report" */ "@/views/home/report.vue"),
          meta: { title: "report", icon: "report", roles: ['admin'] }
        },
      ]
    },
    {
      path: "/administration",
      component: Layout,
      name: "Administration",
      redirect: "/administration/customer",
      meta: { title: "Administration", icon: "management", roles: ['admin'] },
      children: [
        {
          path: "customer",
          name: "customer",
          component: () =>
            import(/* webpackChunkName: "administration-customer" */ "@/views/administration/customer.vue"),
          meta: { title: "customers", icon: "customer", roles: ['admin'], }
        },
        {
          path: "wallet",
          name: "wallet",
          component: () =>
            import(/* webpackChunkName: "administration-wallet" */ "@/views/administration/wallet.vue"),
          meta: { title: "wallets", icon: "wallet", roles: ['admin'], }
        },
        {
          path: "application",
          name: "application",
          component: () =>
            import(/* webpackChunkName: "administration-application" */ "@/views/administration/application.vue"),
          meta: { title: "applications", icon: "application", roles: ['admin'], },
        },
        // {
        //   path: "messageVerify",
        //   name: "messageVerify",
        //   component: () =>
        //     import(/* webpackChunkName: "administration-messageVerify" */ "@/views/administration/messageVerify.vue"),
        //   meta: { title: "message verify", icon: "text", roles: ['admin'], }
        // },
      ]
    },
    {
      path: "/management",
      component: Layout,
      name: "management",
      redirect: "/management/account",
      meta: { title: "CMS", icon: "admin", roles: ['admin'] },
      children: [
        {
          path: "account",
          name: "account",
          component: () =>
            import(/* webpackChunkName: "management-account" */ "@/views/management/account.vue"),
          meta: { title: "accounts", icon: "accounts", roles: ['admin'], }
        },
        {
          path: "setting",
          name: "setting",
          component: () =>
            import(/* webpackChunkName: "management-setting" */ "@/views/management/setting.vue"),
          meta: { title: "settings", icon: "setting", roles: ['admin'], }
        },
        {
          path: "vendors",
          name: "vendors",
          component: () =>
            import(/* webpackChunkName: "management-vendor" */ "@/views/management/vendor.vue"),
          meta: { title: "vendors", icon: "booth", roles: ['admin'], }
        },
      ]
    },
    {
      path: "/log",
      component: Layout,
      name: "Log",
      redirect: "/index",
      meta: { title: "Logs", icon: "logs", roles: ['admin'], alwaysShow: true, },
      children: [
        {
          path: "actionHistory",
          name: "actionHistory",
          component: () =>
            import(/* webpackChunkName: "log-actionHistory" */ "@/views/log/actionHistory.vue"),
          meta: { title: "actions", icon: "action", roles: ['admin'], }
        },
        {
          path: "transaction",
          name: "transaction",
          component: () =>
            import(/* webpackChunkName: "log-transaction" */ "@/views/log/transaction.vue"),
          meta: { title: "transactions", icon: "transaction", roles: ['admin'], }
        },
        {
          path: "phone",
          name: "phone",
          component: () =>
            import(/* webpackChunkName: "log-phone" */ "@/views/log/phone.vue"),
          meta: { title: "phone", icon: "iphones", roles: ['admin'], }
        },
        {
          path: "smsMessage",
          name: "smsMessage",
          component: () =>
            import(/* webpackChunkName: "log-smsMessage" */ "@/views/log/smsMessage.vue"),
          meta: { title: "sms", icon: "sms", roles: ['admin'], }
        },
        // {
        //   path: "whatsAppMessage",
        //   name: "whatsAppMessage",
        //   component: () =>
        //     import(/* webpackChunkName: "log-whatsAppMessage" */ "@/views/log/whatsAppMessage.vue"),
        //   meta: { title: "whatsApp", icon: "sms", roles: ['admin'], }
        // },
        // {
        //   path: "whatsAppMessageWebhook",
        //   name: "whatsAppMessageWebhook",
        //   component: () =>
        //     import(/* webpackChunkName: "log-whatsAppMessageWebhook" */ "@/views/log/whatsAppMessageWebhook.vue"),
        //   meta: { title: "whatsApp webhook", icon: "sms", roles: ['admin'], }
        // },
        // {
        //   path: "whatsAppRateLimit",
        //   name: "whatsAppRateLimit",
        //   component: () =>
        //     import(/* webpackChunkName: "log-whatsAppRateLimit" */ "@/views/log/whatsAppRateLimit.vue"),
        //   meta: { title: "whatsApp limit", icon: "rateLimit", roles: ['admin'], }
        // },
        {
          path: "whatsappOutgoing",
          name: "whatsappOutgoing",
          component: () =>
            import(/* webpackChunkName: "log-whatsappOutgoing" */ "@/views/log/whatsappOutgoingMessage.vue"),
          meta: { title: "whatsapp outgoing", icon: "sms", roles: ['admin'], }
        },
        {
          path: "whatsappIncoming",
          name: "whatsappIncoming",
          component: () =>
            import(/* webpackChunkName: "log-whatsappIncoming" */ "@/views/log/whatsappIncomingMessage.vue"),
          meta: { title: "whatsapp incoming", icon: "api", roles: ['admin'], }
        },
        {
          path: "whatsappTemplate",
          name: "whatsappTemplate",
          component: () =>
            import(/* webpackChunkName: "log-whatsappTemplate" */ "@/views/log/whatsappTemplate.vue"),
          meta: { title: "whatsapp template", icon: "api", roles: ['admin'], }
        },
        {
          path: "logRequest",
          name: "logRequest",
          component: () =>
            import(/* webpackChunkName: "log-logRequest" */ "@/views/log/logRequest.vue"),
          meta: { title: "api request", icon: "api", roles: ['admin'], }
        },
      ]
    },
    {
      path: "/logout",
      component: Layout,
      name: "Logout",
      redirect: "index",
      meta: { title: "Logout", icon: "logout" },
      children: [
        {
          path: "index",
          name: "logout",
          component: () =>
            import(/* webpackChunkName: "logout-index" */ "@/views/logout/index.vue"),
          meta: { title: "Logout", icon: "logout" }
        },
      ]
    },
    { path: "*", redirect: "/404" }
  ]
});
